// @flow
import { Button, PageTitle } from '~/components/widgets';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ImageContainer, MainWrapper, MessageContainer, PopupWrapper, TextContainer } from './styles';

import messages from './intl';
import PropTypes from 'prop-types';
import * as React from 'react';

const propTypes = {
    dismissPopup: PropTypes.func.isRequired
};

const NewWebsiteAlert = ({ dismissPopup }) => (
    <MainWrapper>
        <PopupWrapper>
            <ImageContainer />
            <TextContainer>
                <PageTitle>
                    <FormattedMessage {...messages.title} />
                </PageTitle>
                <MessageContainer>
                    <FormattedMessage {...messages.hello} />
                </MessageContainer>
                <MessageContainer>
                    <FormattedMessage {...messages.thankYouMessage} />
                </MessageContainer>
                <MessageContainer>
                    <FormattedMessage {...messages.changeMessage} />
                </MessageContainer>
                <MessageContainer>
                    <FormattedMessage
                        {...messages.thanksAgain}
                        values={{
                            break: <br />
                        }}
                    />
                </MessageContainer>
                <Button onClick={dismissPopup} type="submit">
                    <FormattedMessage {...messages.ok} />
                </Button>
            </TextContainer>
        </PopupWrapper>
    </MainWrapper>
);
//<b><FormattedMessage {...menuMessages.settings} /></b>
NewWebsiteAlert.propTypes = propTypes;
export default injectIntl(NewWebsiteAlert);



// WEBPACK FOOTER //
// ./src/components/widgets/new-website-popup/component.js